import { AccountAvatar } from "@/components/controls/AccountAvatar"
import { FONT_STYLES } from "@/styles/fonts"

interface LandingHeaderProps {
  isAuthed: boolean
  initializing?: boolean
  onSignInClick?: () => void
}

export default function LandingHeader({
  isAuthed,
  initializing = false,
  onSignInClick,
}: LandingHeaderProps) {
  return (
    <header className="absolute top-0 right-0 p-4 z-40 flex items-center gap-3">
      {initializing ? (
        <div className="w-8 h-8 rounded-full bg-white/20 animate-pulse shadow-lg" />
      ) : isAuthed ? (
        <AccountAvatar size={32} className="shadow-lg" />
      ) : (
        <button
          onClick={onSignInClick}
          className="px-6 py-2 bg-white/90 text-gray-900 rounded-md text-sm tracking-wide hover:bg-white transition-colors shadow-lg"
          style={FONT_STYLES.alga}
        >
          Sign In
        </button>
      )}
    </header>
  )
}
